import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    nameKey: "testimonial.name1",
    reviewKey: "testimonial.review1",
    image: "/assets/testimonials/testimonial1.jpg",
  },
  {
    nameKey: "testimonial.name2",
    reviewKey: "testimonial.review2",
    image: "/assets/testimonials/testimonial2.jpg",
  },
  {
    nameKey: "testimonial.name3",
    reviewKey: "testimonial.review3",
    image: "/assets/testimonials/testimonial3.jpg",
  },
];

const Testimonials = () => {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-100 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-purple-700 mb-8"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {t("testimonial.title")}
        </motion.h2>

        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: index * 0.1 }}
            >
              <img
                src={testimonial.image}
                alt={t(testimonial.nameKey)}
                className="w-24 h-24 rounded-full mx-auto mb-4"
              />
              <p className="text-gray-600 mb-4">
                "{t(testimonial.reviewKey)}"
              </p>
              <h4 className="font-semibold text-purple-800">
                {t(testimonial.nameKey)}
              </h4>
            </motion.div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
